import React, { useState } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { SwitchBack } from "../Redux/Switch";
import Hero from "../Components/Hero";
import About from "../Components/About";
import I_DO from "../Components/I_DO";
import Experience from "../Components/Experience";
import Projects from "../Components/Projects";
import My_Map from "../Components/My_Map";
import Message from "../Components/Message";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";
import Scr from "../img/Scl.png";
import Scr2 from "../img/Scl2.png";
import { Mobile, Landscape } from "../Response";
import { useEffect } from "react";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightlightRoundIcon from "@mui/icons-material/NightlightRound";

const Home = () => {
  const dispatch = useDispatch();
  const [swipUp, setSwipUp] = useState(false);
  const [show, setShow] = useState(false);
  const back = useSelector((state) => state.switch.back);

  useEffect(() => {
    window.addEventListener("scroll", ListenToScroll);
    return () => {
      window.removeEventListener("scroll", ListenToScroll);
    };
  }, []);
  const ListenToScroll = () => {
    let Y = 120;
    const WinScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (WinScroll > Y) {
      !swipUp && setSwipUp(true);
    } else {
      setSwipUp(false);
    }
  };

  return (
    <Contain back={back}>
      <Hero />
      <About />
      <I_DO />
      <Experience />
      <Projects />
      <My_Map />
      <Message />
      <Footer />
      {swipUp && (
        <Cont onClick={() => setShow(!show)}>
          <ImgSc src={back == "sun" ? Scr : Scr2} />
        </Cont>
      )}
      {show && <ContactBack onClick={() => setShow(!show)} />}
      {show && (
        <ContactCon>
          <Contact />
        </ContactCon>
      )}
      <SwitchCon>
        {back === "sun" ? (
          <S_icon back={back}>
            <NightlightRoundIcon
              className="switch"
              onClick={() => dispatch(SwitchBack())}
            />
          </S_icon>
        ) : (
          <S_icon back={back}>
            <LightModeIcon
              className="switch sun"
              onClick={() => dispatch(SwitchBack())}
            />
          </S_icon>
        )}
      </SwitchCon>
    </Contain>
  );
};
export default Home;
const Contain = styled.div`
  max-width: 100vw;
  overflow: hidden;
  overflow-x: hidden;
  position: relative;
  background: ${(props) =>
    props.back === "sun" ? "rgb(250, 253, 255)" : "#0d1116"};
`;
const Cont = styled.div`
  z-index: 5;
  cursor: pointer;
  width: 150px;
  height: 80px;
  // border-radius: 50%;
  // background: green;
  position: fixed;
  bottom: -30px;
  transition: all 0.8s;
  // right: 0;
  transform: translateX(45vw);
  // transform: translateX(-150);
  opacity: 0.4;
  &:hover {
    opacity: 1;
  }
  ${Mobile({
    width: 100,
    height: 60,
    bottom: -28,
    transform: "translateX(37vw)",
  })}
  ${Landscape({ display: "none" })}
`;
const ImgSc = styled.img`
  width: 100%;
  // height: 100%;
`;

const ContactBack = styled.div`
  width: 100%;
  height: 100%;
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(239, 243, 245, 0.15);
  backdrop-filter: blur(10px);
  ${Mobile({
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
  })}
`;
const ContactCon = styled.div`
  width: 56%;
  height: 90%;
  z-index: 5;
  position: fixed;
  top: 0;
  // background: red;
  // backdrop-filter: blur(10px);
  margin-left: 22.5%;
  margin-top: 2%;
  ${Mobile({ width: "95vw", height: "90vh", marginLeft: "2.5%" })}
`;
const SwitchCon = styled.div`
  width: 8vw;
  height: 6vh;
  margin: 16px;

  position: absolute;
  top: 0;
  right: 0;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.85;
  z-index: 10;
  ${Landscape({
    width: "10vw",
    height: "12vh",
    margin: "12px",
    position: "fixed",
  })}
  ${Mobile({ width: '16vw',
    height: '6vh'})}
  &:hover {
    opacity: 1;
  }
`;
const S_icon = styled.div`
  background: ${(props) =>
    props.back === "sun" ? "rgba(226, 232, 235, 0.6)" : "rgba(26, 32, 39,0.8)"};
  cursor: pointer;
  width: 90%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  .switch {
    color: rgba(12, 12, 28, 0.8);
  }
  .sun {
    color: rgba(228, 236, 240, 0.847);
  }

`;
